import { ReactNode } from "react"
import { Checkbox, FormControlLabel, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    card: {
        margin: 0,
        padding: ".625rem .75rem .625rem .375rem",
        border: `1px solid ${theme.palette.tailwind.gray[200]}`,
        borderRadius: ".5rem",
        alignItems: "flex-start",
    },
}))

type Props = Readonly<{
    checked: boolean
    onChange: (checked: boolean) => void
    label: ReactNode
    sublabel?: ReactNode
}>

/** A checkbox in a bordered card with a bold label and an optional muted explanation. */
export function CheckboxCard({ checked, onChange, label, sublabel }: Props) {
    const { classes } = useStyles()

    return (
        <FormControlLabel
            className={classes.card}
            control={<Checkbox size="small" checked={checked} onChange={(event) => onChange(event.target.checked)} />}
            label={
                <Stack spacing=".125rem">
                    {label}
                    {sublabel}
                </Stack>
            }
        />
    )
}
